import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import hero3Styles from './Hero3Styles';
import Button from "../Button/Button";
import HazelHeroIcon from '../../icons/HazelHeroIcon';

type ContentProps = {

};

const StyledHero3 = styled('section')(({ theme }) => hero3Styles(theme));

const hazelHeroClassNames = {
  heroStyledContainer: 'flex relative overflow-hidden',
  heroBackgroundIcon: 'w-full h-full absolute',
  heroContentContainer: 'py-12 container mx-auto md:py-24 lg:py-48 z-10',
  heroContentInnerContainer: 'flex flex-col xl:flex-row mt-24 lg:mt-0 items-center',
  heroTextContainer: 'flex flex-col xl:w-1/2 px-12',
  heroAltTitle: 'mt-4 xl:text-left',
  heroTitle: 'mt-6 font-bold text-5xl md:text-7xl lg:text-8xl xl:text-left',
  heroSubtitle: 'mt-8 text-lg  xl:text-left',
  heroButton: 'mt-10 mb-14 w-[20rem]',
  heroImgContainer: 'z-50 px-12 flex justify-center xl:block'
};

const Hero3: React.FC<ContentProps> = () => (
  <Fragment>
    <StyledHero3 id="hero-background" className={hazelHeroClassNames.heroStyledContainer}>
      <HazelHeroIcon id="hero-background-icon" className={hazelHeroClassNames.heroBackgroundIcon}/>
      <div className={hazelHeroClassNames.heroContentContainer}>
        <div className={hazelHeroClassNames.heroContentInnerContainer}>
          <div className={hazelHeroClassNames.heroTextContainer}>
            <div id="hero-alt-title" className={hazelHeroClassNames.heroAltTitle}>
              RENTA DE PLATAFORMAS
            </div>
            <div id="hero-title" className={hazelHeroClassNames.heroTitle}>
              Renta de plataformas<br/> en<br/> Hidalgo
            </div>
            <div id="hero-subtitle" className={hazelHeroClassNames.heroSubtitle}>
              Plataformas con disponibilidad inmediata para transporte de maquinaria, acero y carga pesada.
            </div>
            <div className={hazelHeroClassNames.heroButton}>
              <Button href="/contacto" fullWidth>
                Ver plataformas disponibles
              </Button> 
            </div>
          </div>
          <div className={hazelHeroClassNames.heroImgContainer}>
            <img loading="lazy" id="image-container" alt="Renta de plataformas en Hidalgo" className="w-[30rem] md:w-[55rem] lg:w-[70rem] xl:w-[60rem] 2xl:w-[90rem] xl:ml-[-10rem] 2xl:ml-[-10rem]" src="https://grupogm-assets.s3.us-east-1.amazonaws.com/renta-plataformas/hero-renta-plataformas3.png" />
          </div>
        </div>
      </div>
    </StyledHero3>
  </Fragment>
);

export default Hero3;